export const urn = require('./urn_logo.png');
export const urnBlack = require('./urn_logo_black.png');
export const broken = require('./broken.png');
export const shepherds = require('./shepherds-tm.png');
export const bell = require('./bell.png');
export const location = require('./location.png');
export const bs_icon = require('./icon.png');
export const adaptive_icon = require('./adaptive-icon.png');
export const card_front = require('./card_front.png');
export const card_back = require('./card_back.png');
export const splash_screen = require('./splash.png');
export const adaptiveIcon = require('./adaptive-icon.png');
export const donation = require('./donation.png');
export const churchToClaim = require('./church_to_claim.png');
export const npoEditedNotClaimed = require('./npo_edited_not_claimed.png');
export const npoThumbPlaceholder = require('./npo_thumb_placeholder.png');
